export default "__VITE_ASSET__dtSB2bck__"